import { ApiSyncPayloadTypeEnum } from './apiSyncPayloadType.enum';

export class ApiSyncPayloadDto{
    type: ApiSyncPayloadTypeEnum;
    payload: any;
    message: string;
    status: boolean;
    timestamp: number;
    instanceCode: string;
    signature: string;
}